import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/candidature")({
  component: () => <Outlet />,
});
